import React, { memo, forwardRef } from "react";
const SvgNaturalnumbers = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        d="M12 12.62h-.04v8.82c0 .307-.047.553-.14.74a1.342 1.342 0 01-.34.42.813.813 0 01-.4.2c-.147.04-.273.06-.38.06-.107 0-.233-.02-.38-.06a.938.938 0 01-.42-.2 1.514 1.514 0 01-.32-.42c-.093-.187-.14-.433-.14-.74V10.18c0-.387.06-.7.18-.94s.26-.427.42-.56c.173-.133.347-.22.52-.26.187-.053.34-.08.46-.08.28 0 .56.08.84.24.28.147.587.453.92.92l6.58 9.06h.04v-8.8c0-.293.047-.533.14-.72.093-.187.2-.333.32-.44a.94.94 0 01.42-.2c.147-.04.273-.06.38-.06.107 0 .233.02.38.06.147.027.28.093.4.2.133.107.247.253.34.44.093.187.14.427.14.72v11.26c0 .387-.06.7-.18.94s-.267.427-.44.56c-.16.133-.333.22-.52.26-.173.053-.32.08-.44.08-.293 0-.573-.073-.84-.22-.267-.16-.573-.473-.92-.94L12 12.62z"
      />
    </svg>
  );
});
SvgNaturalnumbers.displayName = "SvgNaturalnumbers";
const MemoForwardRef = memo(SvgNaturalnumbers);
export default MemoForwardRef;
